import { render, staticRenderFns } from "./level-progress.vue?vue&type=template&id=567ed67c&scoped=true"
import script from "./level-progress.vue?vue&type=script&lang=js"
export * from "./level-progress.vue?vue&type=script&lang=js"
import style0 from "./level-progress.vue?vue&type=style&index=0&id=567ed67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ed67c",
  null
  
)

export default component.exports